'use client'

import { paymentStrategies, PaymentStrategyProps, StrategyKey } from './type'

type Props = PaymentStrategyProps & {
  shouldConfirmWithWallet: boolean
  shouldShowPaypalForm: boolean
  shouldShowPaymentForm: boolean
}

export const usePaymentStrategy = ({
  shouldConfirmWithWallet,
  shouldShowPaypalForm,
  shouldShowPaymentForm,
  ...rest
}: Props) => {
  let key: StrategyKey = 'ask'
  if (shouldConfirmWithWallet) key = 'wallet'
  else if (shouldShowPaypalForm) key = 'paypal'
  else if (shouldShowPaymentForm) key = 'stripe'
  const strategy = paymentStrategies[key]

  return strategy(rest)
}
